export default "__VITE_ASSET__zmXRildo__"